/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { onConsent } from './src/utils/oneTrustConsent';

let cleanupConsent = null;

export const onClientEntry = () => {
  cleanupConsent = onConsent({
    // Add callbacks here as needed, e.g.:
    // onAnalytics: () => { console.log('Analytics consent granted'); },
    // onTargeting: () => { console.log('Targeting consent granted'); },
  });
};

// Clean up on page unload (Gatsby doesn't have a dedicated "onClientExit",
// but this handles SPA teardown during development hot-reloads)
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    if (cleanupConsent) cleanupConsent();
  });
}
